module.exports = "/assets/data/987b57c68cfb10ed05d8396854cf13f0-EX7.data.json";